<script>
    import Cabecera from "../../Components/Layout/Cabecera.svelte";
</script>

<Cabecera navegacion="false" />

<main>
    <slot />
</main>